import { c as _c } from "react/compiler-runtime";
import { StyleProps } from 'shared/ui/uiType';
import { SquareIconProps } from './icons';
import { ReactNode, useContext } from 'react';
import { IconContext } from 'react-icons';
import { pick } from 'remeda';
type IconProps = SquareIconProps & StyleProps;
const Svg = t0 => {
  const $ = _c(13);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  const ctx = useContext(IconContext);
  let t1;
  if ($[3] !== ctx) {
    t1 = pick(ctx, ["className", "color", "size"]);
    $[3] = ctx;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let svgProps;
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    ({
      size: t2,
      ...svgProps
    } = {
      ...t1,
      ...props
    });
    $[5] = props;
    $[6] = t1;
    $[7] = svgProps;
    $[8] = t2;
  } else {
    svgProps = $[7];
    t2 = $[8];
  }
  const size = t2 === undefined ? "1em" : t2;
  let t3;
  if ($[9] !== children || $[10] !== size || $[11] !== svgProps) {
    t3 = <svg {...svgProps} width={size} height={size} viewBox="0 0 24 24">{children}</svg>;
    $[9] = children;
    $[10] = size;
    $[11] = svgProps;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export const IconConsequence = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M6 2C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H12C12.7956 22 13.5587 21.6839 14.1213 21.1213C14.6839 20.5587 15 19.7956 15 19V5C15 4.20435 14.6839 3.44129 14.1213 2.87868C13.5587 2.31607 12.7956 2 12 2H6ZM16.293 7.293C16.4805 7.10553 16.7348 7.00021 17 7.00021C17.2652 7.00021 17.5195 7.10553 17.707 7.293L21.707 11.293C21.8945 11.4805 21.9998 11.7348 21.9998 12C21.9998 12.2652 21.8945 12.5195 21.707 12.707L17.707 16.707C17.5184 16.8892 17.2658 16.99 17.0036 16.9877C16.7414 16.9854 16.4906 16.8802 16.3052 16.6948C16.1198 16.5094 16.0146 16.2586 16.0123 15.9964C16.01 15.7342 16.1108 15.4816 16.293 15.293L18.586 13H10C9.73478 13 9.48043 12.8946 9.29289 12.7071C9.10536 12.5196 9 12.2652 9 12C9 11.7348 9.10536 11.4804 9.29289 11.2929C9.48043 11.1054 9.73478 11 10 11H18.586L16.293 8.707C16.1055 8.51947 16.0002 8.26516 16.0002 8C16.0002 7.73484 16.1055 7.48053 16.293 7.293Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const IconCause = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11 2C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V19C8 19.7956 8.31607 20.5587 8.87868 21.1213C9.44129 21.6839 10.2044 22 11 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2H11ZM12.293 8.293C12.4805 8.10553 12.7348 8.00021 13 8.00021C13.2652 8.00021 13.5195 8.10553 13.707 8.293L16.707 11.293C16.8945 11.4805 16.9998 11.7348 16.9998 12C16.9998 12.2652 16.8945 12.5195 16.707 12.707L13.707 15.707C13.5184 15.8892 13.2658 15.99 13.0036 15.9877C12.7414 15.9854 12.4906 15.8802 12.3052 15.6948C12.1198 15.5094 12.0146 15.2586 12.0123 14.9964C12.01 14.7342 12.1108 14.4816 12.293 14.293L13.586 13H5C4.73478 13 4.48043 12.8946 4.29289 12.7071C4.10536 12.5196 4 12.2652 4 12C4 11.7348 4.10536 11.4804 4.29289 11.2929C4.48043 11.1054 4.73478 11 5 11H13.586L12.293 9.707C12.1055 9.51947 12.0002 9.26516 12.0002 9C12.0002 8.73484 12.1055 8.48053 12.293 8.293Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const IconRelated = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4.07251 3.00027C4.97269 2.44516 6.19359 2.1333 7.46663 2.1333H17.0666C18.3397 2.1333 19.5606 2.44516 20.4607 3.00027C21.3609 3.55537 21.8666 4.30826 21.8666 5.0933V18.9066C21.8666 19.6917 21.3609 20.4446 20.4607 20.9997C19.5606 21.5548 18.3397 21.8666 17.0666 21.8666H7.46663C6.19359 21.8666 4.97269 21.5548 4.07251 20.9997C3.17234 20.4446 2.66663 19.6917 2.66663 18.9066V5.0933C2.66663 4.30826 3.17234 3.55537 4.07251 3.00027ZM8.88172 9.34724C9.33125 8.86025 9.30088 8.10106 8.8139 7.65154C8.32691 7.20201 7.56772 7.23238 7.1182 7.71937L3.9182 11.186C3.49388 11.6457 3.49388 12.3542 3.9182 12.8139L7.1182 16.2806C7.56772 16.7676 8.32691 16.7979 8.8139 16.3484C9.30088 15.8989 9.33125 15.1397 8.88172 14.6527L7.54074 13.2H16.4592L15.1182 14.6527C14.6687 15.1397 14.699 15.8989 15.186 16.3484C15.673 16.7979 16.4322 16.7676 16.8817 16.2806L20.0817 12.8139C20.506 12.3542 20.506 11.6457 20.0817 11.186L16.8817 7.71937C16.4322 7.23238 15.673 7.20201 15.186 7.65154C14.699 8.10106 14.6687 8.86025 15.1182 9.34724L16.4592 10.8H7.54074L8.88172 9.34724Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const IconLikelihood = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M19 3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C20.11 21 21 20.11 21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3ZM8.83 7.05C9.81 7.05 10.6 7.84 10.6 8.83C10.6 9.81 9.81 10.6 8.83 10.6C7.84 10.6 7.05 9.81 7.05 8.83C7.05 7.84 7.84 7.05 8.83 7.05ZM15.22 17C14.24 17 13.45 16.2 13.45 15.22C13.45 14.24 14.24 13.45 15.22 13.45C16.2 13.45 17 14.24 17 15.22C17 16.2 16.2 17 15.22 17ZM8.5 17.03L7 15.53L15.53 7L17.03 8.5L8.5 17.03Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const IconAmount = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M2 6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2H18C19.0609 2 20.0783 2.42143 20.8284 3.17157C21.5786 3.92172 22 4.93913 22 6V16C20.234 16 19.11 15.46 18.308 14.708C17.474 13.924 16.914 12.842 16.428 11.628C16.262 11.214 16.114 10.808 15.964 10.4L15.75 9.814C15.5402 9.22454 15.2924 8.64933 15.008 8.092C14.44 7.028 13.55 6 12 6C10.45 6 9.56 7.028 8.992 8.092C8.71 8.624 8.472 9.224 8.252 9.814L8.036 10.4C7.886 10.808 7.736 11.214 7.572 11.628C7.086 12.842 6.526 13.924 5.692 14.708C4.888 15.46 3.762 16 2 16V6ZM2 18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H18C19.0609 22 20.0783 21.5786 20.8284 20.8284C21.5786 20.0783 22 19.0609 22 18C19.764 18 18.14 17.29 16.94 16.168C15.776 15.076 15.086 13.658 14.572 12.372C14.3988 11.9345 14.2321 11.4945 14.072 11.052L13.876 10.512C13.6965 10.0056 13.4847 9.51128 13.242 9.032C12.81 8.224 12.45 8 12 8C11.55 8 11.19 8.22 10.758 9.034C10.54 9.44 10.342 9.934 10.124 10.514L9.926 11.052C9.772 11.474 9.606 11.928 9.428 12.372C8.914 13.658 8.224 15.076 7.058 16.168C5.86 17.29 4.236 18 2 18Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};